module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.list && _vm.list.length) ? _c('ul', _vm._l((_vm.list), function(e) {
    return _c('li', {
      class: ['d-flex reservation-event mx-3 my-2 p-1', {
        selected: (e.id === _vm.selectedEvent)
      }],
      on: {
        "click": function($event) {
          return _vm.select($event, e)
        }
      }
    }, [_c('event', {
      attrs: {
        "event": e,
        "reschedule": _vm.isReschedule
      }
    })], 1)
  }), 0) : _c('p', {
    staticClass: "m-4"
  }, [_vm._v("No products found. Please try again with a broader criteria.")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2fb43a0a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb43a0a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Events.vue
// module id = 1629
// module chunks = 0